module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/icon_down_step-6ced1a2362fd843aece5d0334e2dcfbb.png";